import dayjs from 'dayjs';
import plist from 'plist';

import {
  getApps as getAppsService
} from '../../services/storeServices';

import { firestore, storage } from '../../firebase';

import { validation, status } from '../../utils/constants';

const initialState = {
  fetching: false,
  error: null,
  message: null,
  status: null,
  apps: [],
  noApps: false,
}

// constants
const PREFIX = 'STORE';
const FETCHING = `${PREFIX}/FETCHING`;
const FETCHING_ERROR = `${PREFIX}/FETCHING_ERROR`;
const RESET_STATE = `${PREFIX}/RESET_STATE`;
const DESTROY_STATE = `${PREFIX}/DESTROY_STATE`;

const GET_APPS = `${PREFIX}/GET_APPS`;
const UPLOAD_APP = `${PREFIX}/UPLOAD_APP`;


// actions
const actionFetching = status => ({ type: FETCHING, payload: status });
const actionFetchingError = (error, message, status) => ({ type: FETCHING_ERROR, payload: { error, message, status } });
const actionResetState = () => ({ type: RESET_STATE });
const actionDestroyState = () => ({ type: DESTROY_STATE });

const actionGetApps = payload => ({ type: GET_APPS, payload });
const actionUploadApp = payload => ({ type: UPLOAD_APP, payload });


// thunks
export const getApps = () => async dispatch => {
  dispatch(actionFetching());
  return getAppsService()
    .then(data => {
      dispatch(actionGetApps(data || []));
      dispatch(actionResetState());
    })
    .catch(error => {
      console.log(error);
    });
};


export const uploadApp = payloadRequest => async dispatch => {
  dispatch(actionFetching());
  const documentRef = await firestore.collection('applications').add({
    name: payloadRequest.name,
  })

  if (documentRef.id) {
    let iconRef = null;
    let apkRef = null;
    let manifestRef = null;
    let ipaRef = null;

    if (payloadRequest.icon) iconRef = await storage.ref(`pagatodo_app_store/${documentRef.id}/${payloadRequest.icon.name}`).put(payloadRequest.icon);
    if (payloadRequest.android && payloadRequest.android.file) apkRef =
      await storage.ref(`pagatodo_app_store/${documentRef.id}/android/${payloadRequest.android.version}/${payloadRequest.android.file.name}`).put(payloadRequest.android.file);

    if (payloadRequest.ios.ipa) ipaRef = await storage.ref(`pagatodo_app_store/${documentRef.id}/ios/${payloadRequest.ios.version}/${payloadRequest.ios.ipa.name}`)
      .put(payloadRequest.ios.ipa);

    const createManifest = () => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async function () {
          const newContent = reader.result.replace(/https:\/\/pagatodo.replace\/app.ipa/, await ipaRef.ref.getDownloadURL())
          const virtualManifest = new File([newContent], 'manifest.plist');
          resolve(virtualManifest);
        };

        reader.readAsText(payloadRequest.ios.manifest);
      })
    }


    if (ipaRef.ref) {
      const manifest = await createManifest();
      manifestRef = await storage.ref(`pagatodo_app_store/${documentRef.id}/ios/${payloadRequest.ios.version}/${payloadRequest.ios.manifest.name}`)
        .put(manifest);
    }


    const data = {
      name: payloadRequest.name,
      icon: await iconRef.ref.getDownloadURL(),
      android: [
        apkRef.ref && {
          file_url: apkRef.ref.toString(),
          version: payloadRequest.android.version,
          release_date: dayjs().toString(),
        }
      ],
      ios: [
        ipaRef.ref && {
          file_url: manifestRef.ref.toString(),
          version: payloadRequest.ios.version,
          release_date: dayjs().toString(),
        }
      ]
    };

    if (apkRef.ref.bucket) firestore.collection('applications').doc(documentRef.id).update(data);
  }

  dispatch(actionResetState());
};


// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING:
      return { ...state, fetching: true, status: action.payload || status.STATUS_FETCHING };
    case FETCHING_ERROR:
      return {
        ...state, fetching: false, status: action.payload.status || status.DEFAULT_FETCHING_ERROR,
        error: action.payload.error || validation.DEFAULT_ERROR,
        message: action.payload.message || validation.DEFAULT_ERROR_MESSAGE,
      };
    case RESET_STATE:
      return { ...state, fetching: false, status: null, error: null, message: null };

    case GET_APPS:
      return { ...state, apps: action.payload, noApps: action.payload.length === 0 };
    case UPLOAD_APP:
      return { ...state, apps: [action.payload , ...state.apps] };
  
    default:
      return state;
  }
}
